<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section operations" style="height: 39px;">
        <div class="triggers">
          <div>
            <span style="display: inline-block;width: 50px;color: #333333">{{ $t('common.btn.query') }}</span>
            <el-input
              v-model="searchConditions.likeName"
              style="width: 286px;"
              :placeholder="$t('common.tips.fuzzySearch')"
              @keyup.enter.native="fetchAmsPortList"
            />
            <el-button type="primary" size="mini" @click="fetchAmsPortList">{{ $t('common.btn.query') }}</el-button>
            <!-- 这里需要按租户判断,只有租户id===1才显示 -->
            <el-button v-if="userInfo.tenantId === 1" type="primary" size="mini" @click="toSaveOrEdit(true)">{{ $t('common.btn.new') }}</el-button>
            <el-button v-if="userInfo.tenantId === 1" type="primary" size="mini" @click="toSaveOrEdit(false)">{{ $t('common.btn.edit') }}</el-button>
            <el-button v-if="userInfo.tenantId === 1" type="primary" size="mini" @click="editStatus(1)">{{ $t('CargoMsg.Cargo_Enable') }}</el-button>
            <el-button v-if="userInfo.tenantId === 1" type="primary" size="mini" @click="editStatus(0)">{{ $t('CargoMsg.Cargo_Disable') }}</el-button>
            <el-button v-if="userInfo.tenantId === 1" type="danger" size="mini" @click="toDelete">{{ $t('common.btn.delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid
          config-module="100103"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="searchConditions.total>0"
          config-module="1001031"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchAmsPortList"
        />
      </div>
    </div>
    <!-- AMS港口维护 -->
    <el-dialog
      slot="reference"
      v-el-drag-dialog
      class="dialog"
      :visible.sync="isShowAmsPortMaintain"
      :title="$t('baseInfo.seaport.tabAmsPort.amsPortMaintain')"
      inline-message
      width="800px"
    >
      <el-form ref="amsPortForm" :model="amsPortForm" :rules="amsPortRules" label-width="60px" label-position="right">
        <el-form-item :label="$t('baseInfo.seaport.tabAmsPort.usNo')" prop="usNo">
          <el-input v-model="amsPortForm.usNo" :maxlength="64" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.seaport.tabAmsPort.englishName')" prop="name">
          <el-input v-model="amsPortForm.name" :maxlength="64" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.seaport.tabAmsPort.unNo')" prop="portCode">
          <el-input v-model="amsPortForm.portCode" size="mini" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.seaport.tabAmsPort.country')" prop="countryCode">
          <CountrySelector
            v-model="amsPortForm.countryCode"
          />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.seaport.tabAmsPort.remark')" prop="remark">
          <el-input v-model="amsPortForm.remark" type="textarea" :maxlength="255" :rows="6" size="mini" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini " type="primary" @click="saveOrEdit">{{ $t('common.btn.save') }}</el-button>
        <el-button size="mini " @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CountrySelector from '@/components/Cargo/CountrySelector'
import { getUserInfo } from '@/utils/auth'
import { getCountryList } from '@/api/country'
import { getSeaAmsPortList, deleteSeaAmsPort, addSeaAmsPort, editSeaAmsPort, batchUpdateAmsPortStatus } from '@/api/seaport'

export default {
  name: 'AmsPort',
  components: { CountrySelector },
  data() {
    return {
      userInfo: {},
      operationType: '',
      amsPortContent: '',
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        context: {
          componentParent: self
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
          if (this.selectedNode) {
            const data = this.selectedNode.data
            this.amsPortEditForm = { ...data }
            this.amsPortEditForm.name = data.englishName
            this.amsPortForm = { ...data }
            this.amsPortForm.name = data.englishName
          }
        }
      },
      gridParams: {},
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      countryList: [],
      countryObj: {},
      reversalCountryObj: {},
      isShowAmsPortMaintain: false,
      amsPortForm: {
        uuid: '',
        usNo: '',
        name: '',
        portCode: '',
        countryCode: '',
        remark: '',
        status: 1
      },
      amsPortEditForm: {
        uuid: '',
        usNo: '',
        name: '',
        portCode: '',
        countryCode: '',
        remark: '',
        status: 1
      },
      searchConditions: {
        likeName: '',
        pageNum: 1,
        pageSize: 10,
        total: 4
      },
      amsPortRules: {
        usNo: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error(this.$t('baseInfo.seaport.tabAmsPort.usNoCheck'))
                return
              }
              // 校验通过,放行
              callback()
            }, trigger: 'blur'
          }
        ],
        name: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error(this.$t('baseInfo.seaport.tabAmsPort.englishNameCheck'))
                return
              }
              // 校验通过,放行
              callback()
            }, trigger: 'blur'
          }
        ],
        portCode: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error(this.$t('baseInfo.seaport.tabAmsPort.unNoCheck'))
                return
              }
              // 校验通过,放行
              callback()
            }, trigger: 'blur'
          }
        ],
        countryCode: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error(this.$t('baseInfo.seaport.tabAmsPort.countryCheck'))
                return
              }
              // 校验通过,放行
              callback()
            }, trigger: 'blur'
          }
        ]
      },
      showAmsPortMaintainTitle: this.$t('baseInfo.seaport.tabAmsPort.amsPortMaintain')
    }
  },
  computed: {
    gridApi() {
      return this.gridOptions.api
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    columnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('baseInfo.seaport.tabAmsPort.usNo'),
          field: 'usNo'
        }, {
          headerName: this.$t('baseInfo.seaport.tabAmsPort.englishName'),
          field: 'englishName'
        }, {
          headerName: this.$t('baseInfo.seaport.tabAmsPort.unNo'),
          field: 'portCode'
        }, {
          headerName: this.$t('CargoMsg.Cargo_CountryRegion'),
          field: 'countryCode',
          cellRenderer: params => {
            const country = this.countryList.find(item => {
              return item.code === params.value
            })
            return country ? (self.isZh ? country.chineseName : country.name) : params.value
          }
        }, {
          headerName: this.$t('baseInfo.seaport.tabAmsPort.remark'),
          field: 'remark'
        }]
    }
  },
  mounted() {
    this.userInfo = getUserInfo()
    // 初始化国家列表
    this.fetchCountryList()
  },
  methods: {
    // 获取amsPort列表
    fetchAmsPortList() {
      const self = this
      const params = { ...this.searchConditions }
      getSeaAmsPortList(params).then(res => {
        self.rowData = res.data.list
        this.searchConditions.pageNum = res.data.pageNum
        this.searchConditions.pageSize = res.data.pageSize
        this.searchConditions.total = Number(res.data.total)
      })
    },
    // 获取国家列表
    fetchCountryList() {
      const self = this
      getCountryList().then(res => {
        self.countryList = res.data
        const obj = {}
        const reversal = {}
        self.countryList.map(item => {
          obj[item.code] = item.chineseName
          reversal[item.chineseName] = item.code
          return item
        })

        self.countryObj = obj
        self.reversalCountryObj = reversal
      }).then(() => {
        // 初始化AmsPort
        self.fetchAmsPortList()
      })
    },
    // 去新增或编辑
    toSaveOrEdit(isAdd) {
      if (!isAdd && !this.amsPortEditForm.uuid) {
        this.$message.info(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (!isAdd) {
        this.operationType = 'edit'
        this.amsPortForm = { ...(this.amsPortEditForm) }
      } else {
        this.operationType = 'add'
        this.amsPortForm = {}
      }
      this.isShowAmsPortMaintain = true
    },
    editStatus(status) {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseAtLeastOneRecord'))
        return
      }
      const firstRow = rows[0]
      if (firstRow.status === status) {
        this.$message.warning(this.$t('Message.NotRepeatOperation'))
        return
      }
      const keys = Array.from(rows, p => p.uuid)
      batchUpdateAmsPortStatus({ keys, status }).then(res => {
        this.$message.success(this.$t('Message.EditedSuccessfully'))
        this.fetchAmsPortList()
      })
    },
    // 去删除
    toDelete() {
      if (!this.amsPortForm.uuid) {
        this.$message.info(this.$t('common.tips.hasOneAtleast'))
      } else {
        this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          deleteSeaAmsPort(this.amsPortForm.uuid).then(res => {
            this.amsPortForm = {}
            this.$message({
              type: 'success',
              message: this.$t('common.tips.deleteSuccess')
            })
          }).then(() => {
            this.fetchAmsPortList()
          })
        }).then(res => {
          this.fetchAmsPortList()
        }).catch(() => {
          this.amsPortForm = {}
          this.$message({
            type: 'info',
            message: this.$t('common.tips.cancelDelete')
          })
        })
      }
    },
    // 保存amsPort
    saveAmsPort() {
      this.$refs.amsPortForm.validate((valid) => {
        const params = {
          uuid: this.amsPortForm.uuid,
          code: this.amsPortForm.usNo,
          name: this.amsPortForm.name,
          portCode: this.amsPortForm.portCode,
          countryCode: this.reversalCountryObj[this.amsPortForm.countryCode],
          remark: this.amsPortForm.remark,
          status: this.amsPortForm.status
        }
        addSeaAmsPort(params).then(res => {
          this.isShowAmsPortMaintain = false
          this.$message({ message: this.$t('common.tips.saveSuccess'), type: 'success' })
        }).then(() => {
          this.fetchAmsPortList()
        })
      })
    },
    // 编辑amsPort
    editAmsPort() {
      this.$refs.amsPortForm.validate((valid) => {
        const params = {
          uuid: this.amsPortForm.uuid,
          code: this.amsPortForm.usNo,
          name: this.amsPortForm.name,
          portCode: this.amsPortForm.portCode,
          countryCode: this.reversalCountryObj[this.amsPortForm.countryCode],
          remark: this.amsPortForm.remark,
          status: this.amsPortForm.status
        }
        editSeaAmsPort(params).then(res => {
          this.isShowAmsPortMaintain = false
          this.$message({ message: this.$t('common.tips.editSuccess'), type: 'success' })
          this.amsPortEditForm = {}
        }).then(() => {
          this.fetchAmsPortList()
        })
      })
    },
    // 保存或者编辑
    saveOrEdit() {
      if (this.operationType === 'edit') {
        this.editAmsPort()
      } else {
        this.saveAmsPort()
      }
    },
    // 取消保存或者编辑
    cancelSaveOrEdit(isAdd) {
      this.isShowAmsPortMaintain = false
      if (!isAdd) {
        this.amsPortEditForm = {}
      } else {
        this.amsPortForm = {}
      }
    }
  }
}
</script>
